export default __webpack_public_path__ + "static/media/ic_paraswap.13898880.svg";